var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74982 17.9997C9.65131 17.9998 9.55374 17.9805 9.46272 17.9428C9.37171 17.9051 9.28904 17.8498 9.21948 17.78L3.96948 12.5305C3.89983 12.4609 3.84457 12.3782 3.80687 12.2872C3.76917 12.1962 3.74976 12.0987 3.74976 12.0002C3.74974 11.8013 3.82874 11.6105 3.96938 11.4698C4.11003 11.3291 4.30079 11.2501 4.49971 11.2501C4.69863 11.2501 4.8894 11.3291 5.03007 11.4697L9.74982 16.1891L19.7194 6.21971C19.86 6.07904 20.0508 6.00001 20.2497 6C20.4487 5.99999 20.6395 6.07901 20.7801 6.21966C20.9208 6.36032 20.9998 6.55109 20.9998 6.75002C20.9998 6.94895 20.9208 7.13973 20.7802 7.2804L10.2802 17.78C10.2106 17.8498 10.1279 17.9051 10.0369 17.9427C9.94589 17.9804 9.84833 17.9998 9.74982 17.9997Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAccept);
export default __webpack_public_path__ + "static/media/action-accept.9e80bd7a90ad0f57854fe4fee89f932b.svg";
export { ForwardRef as ReactComponent };